const DATA_TEST_IDS = {
  fragmentsPasswordForm: 'profile__security_fragments_password-form',
  fragmentsPinCodeForm: 'profile__security_fragments_pin-code-form',
} as const;

export default DATA_TEST_IDS;
